import commonEN from "./en/common"
import commonES from "./es/common"
import dashboardEN from "./en/dashboard"
import dashboardES from "./es/dashboard"
import errorEN from "./en/error"
import errorES from "./es/error"
import kycEN from "./en/kyc"
import kycES from "./es/kyc"
import authEN from "./en/auth"
import authES from "./es/auth"
import settingsEN from "./en/settings"
import settingsES from "./es/settings"
import walletEN from "./en/wallet"
import walletES from "./es/wallet"
import footerEN from "./en/footer"
import footerES from "./es/footer"
import welcomeEN from "./en/welcome"
import welcomeES from "./es/welcome"
import profileEN from "./en/profile"
import profileES from "./es/profile"
import myVotingsEN from "./en/myVotings"
import myVotingsES from "./es/myVotings"
import voteDetailEN from "./en/voteDetail"
import voteDetailES from "./es/voteDetail"
import createWalletEN from "./en/createWallet"
import createWalletES from "./es/createWallet"
import connectWalletEN from "./en/connectWallet"
import connectWalletES from "./es/connectWallet"
import legalEN from "./en/legal"
import legalES from "./es/legal"
import pwaEN from "./en/pwa"
import pwaES from "./es/pwa"
import notificationsEN from "./en/notifications"
import notificationsES from "./es/notifications"
import faqEN from "./en/faq"
import faqES from "./es/faq"
import participationPreferenceEN from "./en/participationPreference"
import participationPreferenceES from "./es/participationPreference"

export const es = {
  auth: authES,
  common: commonES,
  dashboard: dashboardES,
  error: errorES,
  kyc: kycES,
  settings: settingsES,
  wallet: walletES,
  footer: footerES,
  welcome: welcomeES,
  profile: profileES,
  myVotings: myVotingsES,
  voteDetail: voteDetailES,
  createWallet: createWalletES,
  connectWallet: connectWalletES,
  legal: legalES,
  pwa: pwaES,
  notifications: notificationsES,
  faq: faqES,
  participationPreference: participationPreferenceES,
}

export const en = {
  auth: authEN,
  common: commonEN,
  dashboard: dashboardEN,
  error: errorEN,
  kyc: kycEN,
  settings: settingsEN,
  wallet: walletEN,
  footer: footerEN,
  welcome: welcomeEN,
  profile: profileEN,
  myVotings: myVotingsEN,
  voteDetail: voteDetailEN,
  createWallet: createWalletEN,
  connectWallet: connectWalletEN,
  legal: legalEN,
  pwa: pwaEN,
  notifications: notificationsEN,
  faq: faqEN,
  participationPreference: participationPreferenceEN,
}
